import React, { useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Regulatory from "./Regulatory/Index"
import Betting from "./Betting/Index"
import Features from "./Features/Index"
import { useSelector, useDispatch } from "react-redux"
import { getAllRiskManagementSetting } from "store/riskManagement/actions"
import { sitename } from "../../../constants/constants"
import Cashout from "./Cashout/Index"
import Affiliate from "./Affiliate/Index"

function index() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllRiskManagementSetting())
  }, [])
  const RegulatoryData = useSelector(
    state => state.riskManagement.Index.regulatory ?? {}
  )
  const Feature = useSelector(state => state.riskManagement.Index.feature ?? {})
  const BettingLimit = useSelector(
    state => state.riskManagement.Index.bettingLimit ?? {}
  )
  const CashoutData = useSelector(
    state => state.riskManagement.Index.cashout ?? []
  )
  const AffiliateData = useSelector(
    state =>
      state.riskManagement.Index.affiliate ?? {
        cpa_amount: 0,
        revenue_share_percentage: 0,
      }
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Risk Management" breadcrumbItem="Parameters" />
          <Row>
            <Col lg="6">
              {Object.keys(BettingLimit).length > 0 ? (
                <Betting data={BettingLimit} />
              ) : null}

              {Object.keys(RegulatoryData).length > 0 ? (
                <Regulatory data={RegulatoryData} />
              ) : null}
            </Col>
            <Col lg="6">
              {Object.keys(Feature).length > 0 ? (
                <Features data={Feature} />
              ) : null}
              {Object.keys(CashoutData).length > 0 ? (
                <Cashout data={CashoutData} />
              ) : null}

              <Affiliate data={AffiliateData} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default index
